// extracted by mini-css-extract-plugin
export default {"container":"area-chart_container__fiby7","reference-line":"area-chart_reference-line__bz674","axis-label":"area-chart_axis-label__vkyaq","axis":"area-chart_axis__EEH5o"};